"use client";

import dynamic from "next/dynamic";

const Insights = dynamic(
  () => import("@vercel/speed-insights/next").then((module) => module.SpeedInsights),
  { ssr: false }
);

export default function SpeedInsights() {
  return <Insights />;
}
